var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 34,
    viewBox: "0 0 51 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.981445 6.44981V37.156C0.981445 39.6068 2.90831 41.5945 5.28452 41.5945H5.363C7.73921 41.5945 9.66607 39.6068 9.66607 37.156V0.981201H49.8693V37.156C49.8693 39.6068 47.9424 41.5945 45.5662 41.5945H5.32376",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38184 3.45337V37.3854",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7886 11.0667H13.6309V23.2243H25.7886V11.0667Z",
    fill: "#3C8EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3954 5.22339H13.6309V9.06338H46.3954V5.22339Z",
    fill: "#3C8EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 11.9871H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 15.6426H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 19.3H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 22.9575H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 26.615H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 30.2725H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 33.9282H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 37.5857H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.85,
    height: 42.5755,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperSmall);
export default __webpack_public_path__ + "static/media/paper-small.6d2a6d6535ff629fcd70174535197f6f.svg";
export { ForwardRef as ReactComponent };